import { MantineNumberSize, TableProps } from '@mantine/core'

export const DEFAULT_TABLE_FONT_SIZE: MantineNumberSize = 'sm' as const
export const DEFAULT_TABLE_TABLE_VERTICAL_SPACING: MantineNumberSize =
  'xs' as const
export const DEFAULT_TABLE_TABLE_HORIZONTAL_SPACING: MantineNumberSize =
  'xs' as const

export const DEFAULT_TABLE_PROPS: Omit<
  TableProps,
  'fontSize' | 'verticalSpacing' | 'horizontalSpacing'
> & {
  fontSize: MantineNumberSize
  verticalSpacing: MantineNumberSize
  horizontalSpacing: MantineNumberSize
} = {
  fontSize: DEFAULT_TABLE_FONT_SIZE,
  verticalSpacing: DEFAULT_TABLE_TABLE_VERTICAL_SPACING,
  horizontalSpacing: DEFAULT_TABLE_TABLE_HORIZONTAL_SPACING,
}

export const SORT_FILTER_TRAIT_SORT_DIRECTION_DESC = 'desc' as const
export const SORT_FILTER_TRAIT_SORT_DIRECTION_ASC = 'asc' as const

export const SORT_FILTER_TRAIT_FULLTEXT = 'fulltext' as const
export const SORT_FILTER_TRAIT_VALUE = 'value' as const
export const SORT_FILTER_TRAIT_THREE_SIDED_BOOLEAN =
  'threeSidedBoolean' as const
export const SORT_FILTER_TRAIT_MULTIVALUE = 'multiValue' as const
export const SORT_FILTER_TRAIT_COMPONENT = 'component' as const
export const SORT_FILTER_TRAIT_DATERANGE = 'daterange' as const

export const FILTER_TYPES = [
  SORT_FILTER_TRAIT_FULLTEXT,
  SORT_FILTER_TRAIT_VALUE,
  SORT_FILTER_TRAIT_THREE_SIDED_BOOLEAN,
  SORT_FILTER_TRAIT_MULTIVALUE,
  SORT_FILTER_TRAIT_DATERANGE,
] as const

export const SORT_FILTER_TRAIT_UNRESTRICTED_VALUE = 'unrestricted' as const

export const SELECT_COLUMN_ID = 'select_column' as const
export const ACTION_COLUMN_ID = 'action_column' as const
export const EXPORT_VALUE_CELL_FIELD = 'exportValue' as const

export const COUNT_TEXT_ORIENTATION_STACK = 'stack' as const
export const COUNT_TEXT_ORIENTATION_GROUP = 'group' as const

export const COUNT_TEXT_ORIENTATIONS = [
  COUNT_TEXT_ORIENTATION_STACK,
  COUNT_TEXT_ORIENTATION_GROUP,
] as const
